"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepPerformanceMonitor = void 0;
var realms_utils_1 = require("realms-utils");
var StepPerformanceMonitor = /** @class */ (function () {
    function StepPerformanceMonitor(bufferSize) {
        this.buffer = new realms_utils_1.BufferList(bufferSize);
    }
    StepPerformanceMonitor.prototype.addPerformance = function (stepPerformance) {
        this.buffer.push(stepPerformance);
    };
    StepPerformanceMonitor.prototype.getPerformance = function () {
        var values = this.buffer.getItems();
        if (values.length === 0) {
            return {
                onGameStepStart: { durationMs: 0, systems: {} },
                systems: {},
                onGameStepEnd: { durationMs: 0, systems: {} },
            };
        }
        return {
            onGameStepStart: this.getStepStageBreakdownAverage(values.map(function (b) { return b.onGameStepStart; })),
            systems: this.getSystemsBreakdownAverage(values.map(function (b) { return b.systems; })),
            onGameStepEnd: this.getStepStageBreakdownAverage(values.map(function (b) { return b.onGameStepEnd; })),
        };
    };
    StepPerformanceMonitor.prototype.getSystemsBreakdownAverage = function (systemsBreakdown) {
        var e_1, _a, e_2, _b;
        var _c, _d, _e, _f;
        var totalProcessBeforeStepMs = {};
        var totalSystemStepMs = {};
        var totalProcessAfterStepMs = {};
        var totalTotalMs = {};
        var systems = new Set();
        try {
            for (var systemsBreakdown_1 = __values(systemsBreakdown), systemsBreakdown_1_1 = systemsBreakdown_1.next(); !systemsBreakdown_1_1.done; systemsBreakdown_1_1 = systemsBreakdown_1.next()) {
                var breakdown = systemsBreakdown_1_1.value;
                try {
                    for (var _g = (e_2 = void 0, __values(Object.entries(breakdown))), _h = _g.next(); !_h.done; _h = _g.next()) {
                        var _j = __read(_h.value, 2), systemName = _j[0], performanceBreakdown = _j[1];
                        systems.add(systemName);
                        totalProcessBeforeStepMs[systemName] =
                            performanceBreakdown.processBeforeStepMs +
                                ((_c = totalProcessBeforeStepMs[systemName]) !== null && _c !== void 0 ? _c : 0);
                        totalSystemStepMs[systemName] =
                            performanceBreakdown.systemStepMs +
                                ((_d = totalSystemStepMs[systemName]) !== null && _d !== void 0 ? _d : 0);
                        totalProcessAfterStepMs[systemName] =
                            performanceBreakdown.processAfterStepMs +
                                ((_e = totalProcessAfterStepMs[systemName]) !== null && _e !== void 0 ? _e : 0);
                        totalTotalMs[systemName] =
                            performanceBreakdown.totalMs + ((_f = totalTotalMs[systemName]) !== null && _f !== void 0 ? _f : 0);
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (systemsBreakdown_1_1 && !systemsBreakdown_1_1.done && (_a = systemsBreakdown_1.return)) _a.call(systemsBreakdown_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return Object.fromEntries(Array.from(systems.values()).map(function (system) {
            var _a, _b, _c, _d;
            return [
                system,
                {
                    processBeforeStepMs: ((_a = totalProcessBeforeStepMs[system]) !== null && _a !== void 0 ? _a : 0) / systemsBreakdown.length,
                    systemStepMs: ((_b = totalSystemStepMs[system]) !== null && _b !== void 0 ? _b : 0) / systemsBreakdown.length,
                    processAfterStepMs: ((_c = totalProcessAfterStepMs[system]) !== null && _c !== void 0 ? _c : 0) / systemsBreakdown.length,
                    totalMs: ((_d = totalTotalMs[system]) !== null && _d !== void 0 ? _d : 0) / systemsBreakdown.length,
                },
            ];
        }));
    };
    StepPerformanceMonitor.prototype.getStepStageBreakdownAverage = function (breakdowns) {
        var e_3, _a, e_4, _b;
        var _c;
        if (breakdowns.length === 0) {
            throw new Error("No data provided");
        }
        var totalDurationMs = 0;
        var totalSystemDurationMs = {};
        try {
            for (var breakdowns_1 = __values(breakdowns), breakdowns_1_1 = breakdowns_1.next(); !breakdowns_1_1.done; breakdowns_1_1 = breakdowns_1.next()) {
                var breakdown = breakdowns_1_1.value;
                totalDurationMs += breakdown.durationMs;
                try {
                    for (var _d = (e_4 = void 0, __values(Object.entries(breakdown.systems))), _e = _d.next(); !_e.done; _e = _d.next()) {
                        var _f = __read(_e.value, 2), system = _f[0], config = _f[1];
                        totalSystemDurationMs[system] =
                            config.durationMs + ((_c = totalSystemDurationMs[system]) !== null && _c !== void 0 ? _c : 0);
                    }
                }
                catch (e_4_1) { e_4 = { error: e_4_1 }; }
                finally {
                    try {
                        if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
                    }
                    finally { if (e_4) throw e_4.error; }
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (breakdowns_1_1 && !breakdowns_1_1.done && (_a = breakdowns_1.return)) _a.call(breakdowns_1);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return {
            durationMs: totalDurationMs / breakdowns.length,
            systems: Object.fromEntries(Object.entries(totalSystemDurationMs).map(function (_a) {
                var _b = __read(_a, 2), system = _b[0], durationMs = _b[1];
                return [
                    system,
                    { durationMs: durationMs / breakdowns.length },
                ];
            })),
        };
    };
    return StepPerformanceMonitor;
}());
exports.StepPerformanceMonitor = StepPerformanceMonitor;
